export const fillArray = (entries: number) => Array.from(Array(entries).keys());
